import React from 'react';

export function ThymosinAlpha1Diagram() {
  return (
    <svg viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
      {/* Background gradient */}
      <defs>
        <linearGradient id="bg-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f0f4ff" />
          <stop offset="100%" stopColor="#e6f0ff" />
        </linearGradient>
        <linearGradient id="cell-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#d4e4fa" />
          <stop offset="100%" stopColor="#b7d1f8" />
        </linearGradient>
        <linearGradient id="cytokine-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffedd5" />
          <stop offset="100%" stopColor="#fed7aa" />
        </linearGradient>
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* Background */}
      <rect width="800" height="600" fill="url(#bg-gradient)" rx="15" ry="15" />

      {/* Title */}
      <text x="400" y="40" fontSize="24" fontWeight="bold" textAnchor="middle" fill="#3b82f6">
        Thymosin Alpha-1 Mechanism of Action
      </text>

      {/* Cell, representing a dendritic cell */}
      <ellipse cx="200" cy="200" rx="100" ry="80" fill="url(#cell-gradient)" stroke="#4b73b9" strokeWidth="2" />
      <text x="200" y="200" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
        Dendritic Cell
      </text>
      <text x="200" y="225" fontSize="12" textAnchor="middle" fill="#1e40af">
        Antigen Presenting Cell
      </text>

      {/* T Cell */}
      <circle cx="600" cy="200" r="70" fill="url(#cell-gradient)" stroke="#4b73b9" strokeWidth="2" />
      <text x="600" y="195" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
        T Cell
      </text>
      <text x="600" y="215" fontSize="12" textAnchor="middle" fill="#1e40af">
        Adaptive Immunity
      </text>

      {/* Thymosin Alpha-1 Peptide (stylized representation) */}
      <g transform="translate(380, 200)">
        <rect x="-40" y="-15" width="80" height="30" rx="10" ry="10" fill="#93c5fd" stroke="#2563eb" strokeWidth="2" />
        <text x="0" y="7" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          Thymosin α-1
        </text>
      </g>

      {/* TLR Receptor on dendritic cell */}
      <rect x="250" y="170" width="40" height="25" rx="5" ry="5" fill="#fca5a5" stroke="#ef4444" strokeWidth="2" />
      <text x="270" y="187" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#7f1d1d">
        TLR
      </text>

      {/* IL-2 Receptor on T cell */}
      <rect x="540" y="170" width="40" height="25" rx="5" ry="5" fill="#86efac" stroke="#22c55e" strokeWidth="2" />
      <text x="560" y="187" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#14532d">
        IL-2R
      </text>

      {/* Arrows */}
      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto">
          <polygon points="0 0, 10 3.5, 0 7" fill="#6b7280" />
        </marker>
      </defs>

      {/* Connection between Thymosin and TLR */}
      <line x1="340" y1="200" x2="290" y2="180" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* Connection between Thymosin and T Cell */}
      <line x1="420" y1="200" x2="540" y2="180" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* Cytokine production from dendritic cell */}
      <g transform="translate(250, 300)">
        <circle cx="0" cy="0" r="30" fill="url(#cytokine-gradient)" stroke="#f97316" strokeWidth="2" />
        <text x="0" y="5" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#7c2d12">
          IL-12
        </text>
      </g>
      <line x1="200" y1="250" x2="250" y2="280" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* IL-2 production from T cell */}
      <g transform="translate(550, 300)">
        <circle cx="0" cy="0" r="30" fill="url(#cytokine-gradient)" stroke="#f97316" strokeWidth="2" />
        <text x="0" y="5" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#7c2d12">
          IL-2
        </text>
      </g>
      <line x1="600" y1="250" x2="550" y2="280" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* IFN-γ production */}
      <g transform="translate(640, 300)">
        <circle cx="0" cy="0" r="30" fill="url(#cytokine-gradient)" stroke="#f97316" strokeWidth="2" />
        <text x="0" y="5" fontSize="12" fontWeight="bold" textAnchor="middle" fill="#7c2d12">
          IFN-γ
        </text>
      </g>
      <line x1="620" y1="250" x2="640" y2="280" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />

      {/* Effect boxes at bottom */}
      <g transform="translate(200, 450)">
        <rect x="-100" y="-25" width="200" height="50" rx="10" ry="10" fill="#bbf7d0" stroke="#22c55e" strokeWidth="2" />
        <text x="0" y="0" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#14532d">
          Enhanced Antigen
        </text>
        <text x="0" y="20" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#14532d">
          Presentation
        </text>
      </g>

      <g transform="translate(450, 450)">
        <rect x="-100" y="-25" width="200" height="50" rx="10" ry="10" fill="#bbf7d0" stroke="#22c55e" strokeWidth="2" />
        <text x="0" y="0" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#14532d">
          T Cell Proliferation &
        </text>
        <text x="0" y="20" fontSize="14" fontWeight="bold" textAnchor="middle" fill="#14532d">
          Activation
        </text>
      </g>

      <g transform="translate(400, 530)">
        <rect x="-180" y="-25" width="360" height="50" rx="10" ry="10" fill="#bfdbfe" stroke="#3b82f6" strokeWidth="2" />
        <text x="0" y="0" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          Enhanced Immune Response Against
        </text>
        <text x="0" y="20" fontSize="16" fontWeight="bold" textAnchor="middle" fill="#1e40af">
          Viruses, Bacteria, and Tumor Cells
        </text>
      </g>

      {/* Connecting lines to effect boxes */}
      <line x1="250" y1="330" x2="200" y2="420" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />
      <line x1="550" y1="330" x2="450" y2="420" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />
      <line x1="640" y1="330" x2="500" y2="420" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />
      <line x1="200" y1="480" x2="320" y2="520" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />
      <line x1="450" y1="480" x2="400" y2="500" stroke="#6b7280" strokeWidth="2" markerEnd="url(#arrowhead)" />
    </svg>
  );
}